<template>
  <div class="content">
    <h1>miEbooks Feed</h1>
    <div class="datepicker-trigger">
      <input
        type="text"
        id="datepicker-trigger"
        placeholder="Filter by date"
        :value="formatDates(fromDate, toDate)"
      >
      <button v-if="toDate || fromDate" @click="clearDateRange()" class="button" style="margin-top: 2px">Clear</button>

      <AirbnbStyleDatepicker
        :trigger-element-id="'datepicker-trigger'"
        :mode="'range'"
        :monthsToShow="1"
        :fullscreen-mobile="true"
        :date-one="fromDate"
        :date-two="toDate"
        @date-one-selected="val => { fromDate = val }"
        @date-two-selected="val => { toDate = val }"
        :offsetY="0"
        :showShortcutsMenuTrigger="false"
        :fullscreenMobile="false"
        @apply="dateRangeChanged()"
      />
    </div>
    <div class="right-tools no-select">
      <div v-if="!loading" class="icon-button" @click="refreshClicked()"><i class="fal fa-sync-alt"></i></div>
      <div class="loading-small-text" v-else>Refreshing... <loading :small="true" /></div>
    </div>
    <div v-if="mappedStats.length === 0 && !loading" class="events-per-day">
      There are no activities<span v-if="toDate || fromDate"> for the selected dates</span>.
    </div>
    <div v-else class="events-per-day">
      <div v-for="(stats, i) in mappedStats " v-bind:key="i" class="day">
        <div class="date-divider">{{moment(stats.date).format("ddd, D MMMM YYYY")}}</div>
        <div v-for="(stat, j) in stats.stats" v-bind:key="'stat' + j" class="stat">
          <div class="event-icon">
            <i :class="'fal fa-' + utils.getFeedFontAwesomeName(stat.event_name)"></i>
          </div>
          <div class="event-title">
            <div>{{stat.display}}</div>
            <div class="small-date">
              {{moment.unix(stat.timestamp).fromNow()}}
              </div>
          </div>
          <div class="event-date">
            {{moment.unix(stat.timestamp).format("HH:mm:ss")}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import userUtils from '@/utils/userUtils.js';
  import error from '@/utils/error.js'
  import format from 'date-fns/format'
  
  export default {
    name: 'Feed',
    components: {
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       username: '',
       utils: utils,
       moment: moment,
       mappedStats: [],
       stats: [],
       beforeTimestamp: 0,
       fromDate: '',
       toDate: '',
       dateFormat: 'DD MMM YYYY'
      }
    },
    mounted: function () {
      userUtils.checkAuth(this, this.fetchInitialFeedItems);
      window.addEventListener('scroll', this.checkFeedScroll);
    },
    methods: {
      fetchInitialFeedItems(username) {
        this.username = username;

        this.fetchFeedItems('init');
      },
      formatDates(fromDate, toDate) {
        let formattedDates = '';
        if (fromDate) {
          formattedDates = format(fromDate, this.dateFormat);
        }
        if (toDate) {
          formattedDates += ' > ' + format(toDate, this.dateFormat);
        }
        return formattedDates;
      },
      dateRangeChanged() {
        this.mappedStats = []; // clear stats when the date range changes
        this.fetchFeedItems('refresh');
      },
      checkFeedScroll() {
        if(!this.loading) {
            let atBottom = window.scrollY + window.innerHeight > document.body.offsetHeight - 1;

            if (atBottom) {
                this.fetchFeedItems('bottom');
            }
        }
      },
      refreshClicked: function () {
        this.fetchFeedItems('refresh');
      },
      fetchFeedItems: function (action) {
        var t = this;
        t.loading = true;

        var url = t.$config.get('dns') + "/redstone/api/student/timeline?user="+utils.uriEncode(t.username)+"&count=20&exclude=Info"

        if(action === 'refresh') {
          t.beforeTimestamp = 0;
        }

        // if there is a date range, apply the filter
        if(t.fromDate.length > 0) {
          url += "&sinceTimestamp=" + moment(t.fromDate).startOf('day').unix();
        }

        if(t.toDate.length > 0 && action === 'refresh') {
          url += "&beforeTimestamp=" + moment(t.toDate).endOf('day').unix();
        }
        else if(t.beforeTimestamp != 0 && action === 'bottom') {
          // cap it to the fromDate
          if(t.fromDate.length > 0) {
            url += "&beforeTimestamp=" + Math.max(t.beforeTimestamp, moment(t.fromDate).startOf('day').unix());
          } else {
            url += "&beforeTimestamp=" + t.beforeTimestamp;
          }
        } 

        axios.get(url).then(response => {
          var data = _.filter(response.data, function (stat) {
            return stat.display && stat.display.length > 0;
          });

          data = _.orderBy(data, ['timestamp'],['desc']);

          if(data.length > 0) {
            t.beforeTimestamp = data[data.length-1].timestamp;
          }

          if(action === 'init' || action === 'refresh') {
            t.stats = data;
          } else if(action === 'bottom') {
            if(data.length > 0) {
              t.stats = t.stats.concat(data);
            }
          } else {
            t.stats = data.concat(t.stats);
          }

          var statsByDay = _.groupBy(t.stats, event => moment.unix(event.timestamp).format("YYYYMMDD"));
          t.mappedStats = [];
          Object.keys(statsByDay).sort().reverse().forEach(function(key) {
            t.mappedStats.push({stats: statsByDay[key], date: key});
          });
          t.loading = false;
        })
        .catch(e => {
            error.check401And498(t, e);
            t.loading = false;
            t.error = error.logAndGetError(t, e);
        })
      },
      clearDateRange() {
        this.toDate = ''; 
        this.fromDate = ''; 
        this.dateRangeChanged();
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.checkFeedScroll);
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.content {
  height: auto;
}

.events-per-day {
  margin-top: 70px;
}

.fal {
  font-size: 24pt;
  margin-top: 6px;
}

.small-date {
  font-size: 10pt;
  color: $background-color-darker3;
}

.event-date {
  font-size: 10pt;
  color: $dark-font-color-lighter;
  float: right;
  margin-right: 10px;
  margin-top: 10px;
}

.stat {
  display: table;
  border-bottom: 1px solid $background-color-darker1;
  padding: 10px 5px;
  text-align: left;
  width: 100%;
}

.stat .event-icon {
  width: 50px;
}

.stat .event-icon, .stat .event-title, .stat .event-date {
  display: table-cell;
  vertical-align: top;
}

.stat:hover {
  background: $background-color-darker1;
}

.stat img {
  width: 32px;
  vertical-align: top;
}

.loading-small-text {
  top: 8px;
}
.datepicker-trigger input {
  width: 250px;
}

.datepicker-trigger {
  position: absolute;
  margin-bottom: 20px;
}

@media screen and (max-width: 600px) {
  .right-tools {
    float: none;
  }

  .events-per-day {
    margin-top: 20px;
  }

  .datepicker-trigger {
    position: relative;
  }
}
</style>
